import CADAnalyticsScriptLoader from './CADAnalyticsScriptLoader';

export default CADAnalyticsScriptLoader;
